export enum LabelPosition {
  Above = 'above',
  Before = 'before',
  Floating = 'floating',
}
